import styled from "styled-components";

export const ActionButtonsContainer = styled.div`
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    margin-top: -8px;
    margin-bottom: 16px;
    gap: 16px;
`;
